import React, { Component } from 'react';
import styled from 'styled-components';
import * as tokens from '@trp-rps-rps-shared-web/rps-shared-web-styles';
import { connect } from 'react-redux';
import { modalActions } from '../../redux/root-action';
import { modals } from '../../utils/constants';
import ReactModalHeader from '../Modal/ReactModalHeader';
import ReactModalContent from '../Modal/ReactModalContent';

const RIXContentContainer = styled.div`
  > div:nth-child(2) {
    height: calc(100vh - 168px);
    max-height: calc(100vh - 168px);
  }
`;

const RIXContent = styled.div`
  .cq-dd-fragment div:first-child {
    div {
      height: 0;
      font-family: Nimbus Sans Regular;
      font-size: 16px;
      line-height: 1.38;
    }
    ul {
      list-style: disc;
      padding-left: 16px;
      li {
        margin-bottom: 1em;
      }
    }
    table {
      width: 100%;
       {
        td,
        th {
          border: 1px solid ${tokens.ColorGrey800};
          padding: 8px;
        }
      }
    }
  }
`;

class RIXAssumptions extends Component<any> {
  props: any;
  state: any;
  constructor(props: any) {
    super(props);
    this.state = { content: undefined };
  }

  async componentDidMount() {
    const response = await fetch('/content/workplace/en/participant/ri/modals/rix-assumptions.html');
    let data = await response.text();
    data = data.replace(/\s\s+/g, ' ');
    this.setState({ content: data });
  }

  handleCloseIconClick = () => {
    const { hideModal } = this.props;
    hideModal(modals.RIX_ASSUMPTIONS);
  };

  render(): JSX.Element {
    const { content } = this.state;
    return (
      <React.Fragment>
        <RIXContentContainer>
          <ReactModalHeader
            modalTitle="Retirement Income Experience and Confidence Number® Methodology and Assumptions"
            showClose={true}
            handleCloseIconClick={this.handleCloseIconClick}
          />
          <ReactModalContent>
            <RIXContent dangerouslySetInnerHTML={{ __html: content }} />
          </ReactModalContent>
        </RIXContentContainer>
      </React.Fragment>
    );
  }
}

export default connect(null, {
  hideModal: modalActions.hideModal,
})(RIXAssumptions);
